
const Styles = () => import('dev-components/styles/styles.vue').catch(handleImportFailure)
const CrudMetricsDemo = () => import('dev-components/crud-metrics/crud-metrics-demo.vue').catch(handleImportFailure)

function handleImportFailure() {
  window.alert('Error: unable to load resource');
  window.location.href = window.base;
}

export default [
  {
    path: '/styles',
    name: 'Styles',
    component: Styles
  },
  {
    path: '/crud-metrics',
    name: 'CrudMetricsDemo',
    component: CrudMetricsDemo
  }
]
